---
de:
  production_scheduling:
    dialog:
      close: Schließen
      day_ahead_hint: '"Nulllast für morgen" und "Spezifische Last für morgen" wirken sich nur auf das Day-Ahead-Gebot aus, das vor der Frist um 12:00 Uhr gesendet wird. Die heutigen Stunden sowie kontinuierliche/Instant-Aktualisierungen bleiben unverändert.'
      end_date: Enddatum
      end_hour: Endstunde
      instant_send_note: Mit der Bestätigung werden die Intervalle innerhalb der nächsten {days} Tage über den InstantSender (Instant Operations Plan) sofort an den Markt gesendet. Spätere Intervalle erreichen den Markt über den automatischen Ablauf, sobald sie in dieses Zeitfenster fallen. Die geplante Produktion wird im Diagramm „Volumen und Preis“ auf der Registerkarte „Prognose“ aktualisiert.
      instant_send_out_of_window: Der gewählte Zeitraum beginnt außerhalb des {days}-Tage-Marktfensters, daher wird nichts sofort an den Markt gesendet. Das Override aktualisiert dennoch die Prognose und die geplante Produktion und erreicht den Markt über den automatischen Ablauf, sobald es in das Zeitfenster fällt.
      instant_send_partial_window: Der gewählte Zeitraum reicht über das {days}-Tage-Marktfenster hinaus. Die Intervalle innerhalb des Zeitfensters werden sofort an den Markt gesendet; die späteren nicht — sie erreichen den Markt über den automatischen Ablauf, sobald sie in das Zeitfenster fallen.
      override_type: Override-Typ
      production_mw: Produktion (MW)
      send: An Kaia Trade senden
      start_date: Startdatum
      start_hour: Startstunde
      success: "{count} Intervalle gesendet ({accepted} akzeptiert, {rejected} abgelehnt)"
      timezone_hint: Alle Zeiten in {timezone}
      title: Override senden für {name}
    filter:
      all: Alle
      disabled: Aus
      enabled: Ein
      label: 'Produktionsplan:'
    om_dashboard_link: O&M-Dashboard öffnen
    override_types:
      specific_load_interval: Spezifische Last für ein Zeitintervall
      specific_load_tomorrow: Spezifische Last für morgen
      zero_load_tomorrow: Nulllast für morgen
    production_plan_toggle:
      error: 'Produktionsplan konnte nicht aktualisiert werden: {error}'
      label: Produktionsplan
    send_override: Override senden
    shadow_toggle:
      error: 'Shadow-Testing konnte nicht aktualisiert werden: {error}'
      label: Shadow-Testing
    table:
      actions: Aktionen
      company: Unternehmen
      continuous_forecast_enabled: Kontinuierliche Prognose
      day_ahead_forecast_enabled: Day-Ahead-Prognose
      forecast_query_enabled: Prognoseabfrage
      kaia_uuid: Kaia UUID
      last_error: Letzter bekannter Fehler
      last_override_sent: Zuletzt Override gesendet
      last_prod_plan_sent: Zuletzt Prod.-Plan an Trade gesendet
      name: Kraftwerk
      production_simulation_plan_enabled: Produktionsplan
      shadow_testing: Shadow-Testing
      use_price_dependent_bid: Preisabhängiges Gebot
    title: Prod. Planung
